// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const MessageInspirationSourceType = {
  Upload: {
    Name: 'Upload',
    Value: 'upload',
  },
  PinterestBoard: {
    Name: 'Pinterest Board',
    Value: 'pinterest_board',
  },
  GooglePhotosAlbum: {
    Name: 'Google Photos Album',
    Value: 'google_photos_album',
  },
  IcloudAlbum: {
    Name: 'Icloud Album',
    Value: 'icloud_album',
  },
} as const

export type MessageInspirationSourceTypeValue =
  (typeof MessageInspirationSourceType)[keyof typeof MessageInspirationSourceType]['Value']
